<template>
  <div class="image-uploader">
    <div class="preview-area" v-if="imageUrl">
      <img :src="imageUrl" class="preview-image" />
      <button class="remove-btn" @click="removeImage">×</button>
    </div>

    <div class="upload-area" v-else>
      <input
        type="file"
        class="file-input"
        accept="image/*"
        @change="handleImageChange"
        ref="fileInput"
      />
      <div class="upload-placeholder">
        <span>Click or drag image here to upload(Max:20M)</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ImageUploader",
  emits: ["update:modelValue"],
  props: {
    modelValue: {
      type: [File, null],
      default: null,
    },
  },
  data() {
    return {
      imageUrl: null,
    };
  },
  methods: {
    handleImageChange(e) {
      const file = e.target.files[0];
      if (!file) return;
      if (file.size > 20 * 1024 * 1024) {
        alert("File size should not exceed 20MB");
        return;
      }

      this.imageUrl = URL.createObjectURL(file);
      this.$emit("update:modelValue", file);
    },
    removeImage() {
      this.imageUrl = null;
      this.$emit("update:modelValue", null);
      this.$refs.fileInput.value = "";
    },
  },
};
</script>

<style scoped lang="scss">
.image-uploader {
  width: 100%;
  max-width: 300px;

  .preview-area {
    position: relative;
    width: 100%;
    aspect-ratio: 1;

    .preview-image {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: 8px;
    }

    .remove-btn {
      position: absolute;
      top: -10px;
      right: -10px;
      width: 24px;
      height: 24px;
      border-radius: 50%;
      background: #dc3545;
      color: white;
      border: none;
      cursor: pointer;

      &:hover {
        background: darken(#dc3545, 10%);
      }
    }
  }

  .upload-area {
    position: relative;
    width: 100%;
    aspect-ratio: 1;
    border: 2px dashed #dee2e6;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    &:hover {
      border-color: #0d6efd;
    }

    .file-input {
      position: absolute;
      width: 100%;
      height: 100%;
      opacity: 0;
      cursor: pointer;
    }

    .upload-placeholder {
      text-align: center;
      color: #6c757d;

      i {
        font-size: 2rem;
        margin-bottom: 0.5rem;
      }

      span {
        display: block;
        font-size: 0.875rem;
      }
    }
  }
}
</style>
